import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from 'reactstrap';

function PrivacyPolicyPage() {
  return (
    <div className='my-5'>
          <Container className="py-5 px-3 my-3 px-md-5">
      <Row>
        <Col>
          <h1 className="mb-4">Privacy Policy</h1>
          <p>
            Happilee Digital Innovations ("we," "our," or "us") values your privacy. This Privacy Policy explains how we
            collect, use, and share information collected through our hotel booking website. By using our services, you
            agree to the terms outlined in this policy.
          </p>

          <h2 className="mt-4">Information We Collect</h2>
          <h4 className="mt-3">Personal Information:</h4>
          <p>Name, email address, phone number, payment information, and booking details necessary for processing reservations.</p>
          <h4 className="mt-3">Automatically Collected Information:</h4>
          <p>Device information, IP address, and browsing behavior collected through cookies and similar technologies.</p>
          <p>Log data for site analytics and performance improvements.</p>

          <h2 className="mt-4">How We Use Your Information</h2>
          <ul>
            <li>To facilitate hotel bookings and process payments securely.</li>
            <li>To communicate updates, special offers, or changes to your booking.</li>
            <li>To improve our website experience and tailor content to your preferences.</li>
            <li>To comply with legal obligations or enforce our terms of service.</li>
          </ul>

          <h2 className="mt-4">Sharing of Information</h2>
          <ul>
            <li><strong>Payment Processors:</strong> Shared with Razorpay and other payment service providers to process payments.</li>
            <li><strong>Service Providers:</strong> Shared with hotel staff, reservation systems, and third-party vendors as necessary for your booking experience.</li>
            <li><strong>Legal Requirements:</strong> Information may be disclosed to comply with legal obligations or respond to lawful requests.</li>
          </ul>

          <h2 className="mt-4">Security</h2>
          <p>We implement industry-standard security measures, including encryption and secure data storage, to protect your information.</p>

          <h2 className="mt-4">Your Rights</h2>
          <p>You may request access to, correction of, or deletion of your personal information by contacting us at <a href="mailto:happileedigitalinnovations@gmail.com">happileedigitalinnovations@gmail.com</a>.</p>

          <h2 className="mt-4">Changes to the Privacy Policy</h2>
          <p>We reserve the right to update this Privacy Policy periodically. Any changes will be posted on this page.</p>
        </Col>
      </Row>

    </Container>
    </div>
  )
}

export default PrivacyPolicyPage
